import config from "../config";

import { call, put, take } from "redux-saga/effects";
import { eventChannel } from "redux-saga";

const WebSocket = require("isomorphic-ws");

function initWebsocket() {
  return eventChannel(emitter => {
    const ws = new WebSocket(
      config.live
        ? "wss://api.vanzadelhoff.nl/bidsws"
        : "wss://api.vanzadelhoff.nl/testbidsws"
    );

    ws.onopen = () => {
      ws.send(JSON.stringify({ userToken: "token", subscribeTo: "all" }));
    };

    ws.onerror = error => {
      console.error("WebSocket error " + error);
      console.dir(error);
    };

    ws.onmessage = e => {
      let msg = null;
      try {
        msg = JSON.parse(e.data);
      } catch (e) {
        console.error(`Error parsing : ${e.data}`);
      }
      if (msg) {
        console.dir(msg);
      }
    };

    return () => {
      console.warn("Socket off");
    };
  });
}

export default function* websocketSagas() {
  const ch = yield call(initWebsocket);
  while (true) {
    const action = yield take(ch);
    yield put(action);
  }
}



// WEBPACK FOOTER //
// ./src/redux/sockets.js